import { requester } from "@module/_core/infras/config/request/requester";
import { AuthEndpoint } from "../../infras/config/endpointUrl";
import {
    VerifyRecaptchaDTO,
    VerifyOTPDTO,
    VerifyRecaptchaResponseDTO,
    VerifyOTPResponseDTO,
    VerifyRecaptchaData,
    UserSubscriptionDTO
} from "../dto/auth";
import { appRequest } from "@module/_core/infras/config/request/axios";

export class AuthApi {
    static async verifyRecaptcha(verifyRecaptcha: VerifyRecaptchaDTO) {
        return requester<VerifyRecaptchaData>({
            requestFunc: () => appRequest.mapServer.post(AuthEndpoint.verifyRecaptcha(), verifyRecaptcha),
            handleData: (data: VerifyRecaptchaResponseDTO) => data.data
        })();
    }

    static async verifyOTP(verifyOTP: VerifyOTPDTO) {
        return requester<UserSubscriptionDTO>({
            requestFunc: () => appRequest.mapServer.post(AuthEndpoint.verifyOTP(), verifyOTP),
            handleData: (data: VerifyOTPResponseDTO) => data.data
        })();
    }

    static async getUserInfo() {
        return requester<UserSubscriptionDTO>({
            requestFunc: () => appRequest.mapServer.get(AuthEndpoint.getUserInfo()),
            handleData: (data: VerifyOTPResponseDTO) => data.data
        })();
    }

    static async refreshToken(refreshToken: string | null | undefined) {
        if (!refreshToken) return null;
        return requester<UserSubscriptionDTO>({
            requestFunc: () => appRequest.mapServer.post(AuthEndpoint.refreshToken(), { refreshToken }),
            handleData: (data: VerifyOTPResponseDTO) => data.data
        })();
    }
}
